<template>
  <ButtonBase
    :buttonText="buttonText"
    :class="{ 'button-secondary': !disabled }"
    :disabled="disabled"
    :iconLeft="iconLeft"
    :iconRight="iconRight"
    :tabIndex="tabIndex"
    :size="size"
    @onClicked="onClicked"
  ></ButtonBase>
</template>

<script lang="ts" setup>
import ButtonBase from '@/design-system/atoms/buttons/ButtonBase.vue'
interface EMITS {
  (e: 'onClicked')
}
const props = defineProps({
  buttonText: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
  iconLeft: { type: String, default: '' },
  iconRight: { type: String, default: '' },
  size: { type: String, default: 'medium' },
  tabIndex: { type: Number, default: 0 }
})
const emits = defineEmits<EMITS>()

function onClicked() {
  if (!props.disabled) {
    emits('onClicked')
  }
}
</script>

<style lang="scss" scoped>
@use '@/design-system/design-tokens/variables.scss';
.button-secondary {
  background: variables.$color-secondary;
  color: variables.$color-greyscale-content;
  &:hover {
    background: variables.$color-secondary-dark;
    color: variables.$color-pure-white;
  }
  &:focus {
    border: variables.$border-width-xsmall solid variables.$color-secondary;
    box-shadow: variables.$button-outline-focus;
    outline: variables.$border-width-medium solid variables.$color-secondary-light;
  }
}
</style>
